import React from 'react';
import { Grid, Container, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import Loader from 'utils/Loader';
import VendorLedgerController from 'pages/Controller/VendorLedgerController';
import { TableFooter } from '../../../node_modules/@mui/material/index';

const VendorLedger = () => {
  const { ledgerData, totalDebit, totalCredit, cloading, handleViewClick, handleDownloadAll, handleDownloadClick } =
    VendorLedgerController();

  return (
    <div className="bg" style={{ display: 'block' }}>
      {cloading ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Please Wait....</span>
        </div>
      ) : null}
      <Container>
        <div className="cutrange">
          <span className="font20">Vendor Ledger</span>
        </div>

        <Grid container spacing={2} sx={{ mb: 2 }} justifyContent="flex-end">
          <Grid item xs={2}>
            <Button fullWidth variant="contained" color="primary" onClick={handleDownloadAll}>
              Download All
            </Button>
          </Grid>
        </Grid>

        {/* Ledger Table */}
        <TableContainer component={Paper} sx={{ maxHeight: '500px', overflowY: 'auto' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Month
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Opening Balance
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Debit
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Credit
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Balance
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  View Ledger
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Download
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ledgerData.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#e0e0e0' // Zebra-striping effect
                  }}
                >
                  <TableCell align="center">{row.monthname}</TableCell>
                  <TableCell align="center">{row.opening_balance}</TableCell>
                  <TableCell align="center">{row.debit}</TableCell>
                  <TableCell align="center">{row.credit}</TableCell>
                  <TableCell align="center">{row.balance}</TableCell>
                  <TableCell align="center">
                    <Button variant="text" color="primary" onClick={() => handleViewClick(row)} disabled={!row.viewledger}>
                      View
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button variant="text" color="primary" onClick={() => handleDownloadClick(row)} disabled={!row.viewledger}>
                      Download
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

            <TableFooter>
              <TableRow sx={{ color: 'black' }}>
                <TableCell align="center"></TableCell>
                <TableCell align="center" sx={{ color: 'black' }}>
                  Total
                </TableCell>
                <TableCell align="center" sx={{ color: 'black' }}>
                  {totalDebit}
                </TableCell>
                <TableCell align="center" sx={{ color: 'black' }}>
                  {totalCredit}
                </TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Container>
    </div>
  );
};

export default VendorLedger;
